/* ============================================================
   Maravlo — Shipping Protection (verborgen product "Shipping Protection", €4,95)
   Robuuste aanpak (zoals Valor):
   - Prijs wordt als echte winkelwagenregel toegevoegd zodat het bij checkout
     wordt afgerekend.
   - Standaard AAN zodra er (andere) producten in de winkelwagen zitten.
   - Klant kan uitzetten; keuze wordt server-side onthouden via cart-attribuut
     ShippingProtection=No, zodat de bescherming niet automatisch terugkomt.
   - Alle waarheid komt uit Liquid (data-sp-present / data-sp-optout / data-sp-count);
     JS handelt alleen.
   ============================================================ */
(function () {
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var busy = false;

  var SECTIONS = {
    sections: ['cart-drawer', 'cart-icon-bubble'],
    sections_url: window.location.pathname,
  };

  function replaceSection(id, html, selector) {
    if (!html) return;
    var target = document.getElementById(id);
    if (!target) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var source = selector ? doc.querySelector(selector) : doc.getElementById(id);
    if (source) target.innerHTML = source.innerHTML;
  }

  function refresh(state) {
    if (state && state.sections) {
      replaceSection('CartDrawer', state.sections['cart-drawer']);
      replaceSection('cart-icon-bubble', state.sections['cart-icon-bubble'], '.shopify-section');
      var drawer = document.querySelector('cart-drawer');
      if (drawer && drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
    }
    document.dispatchEvent(new CustomEvent('maravlo:cart:updated'));
  }

  function setOptout(value) {
    return fetch(ROOT + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(Object.assign({ attributes: { ShippingProtection: value } }, SECTIONS)),
    }).then(function (r) { return r.json(); });
  }

  function addProtection(variantId) {
    // eerst opt-out wissen, daarna het product toevoegen
    return setOptout('Yes').then(function () {
      return fetch(ROOT + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(Object.assign({ items: [{ id: Number(variantId), quantity: 1 }] }, SECTIONS)),
      }).then(function (r) { return r.json(); });
    });
  }

  function removeProtection(key) {
    return fetch(ROOT + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(Object.assign({ id: key, quantity: 0, attributes: { ShippingProtection: 'No' } }, SECTIONS)),
    }).then(function (r) { return r.json(); });
  }

  /* Toggle wijzigen (delegated: de drawer wordt telkens opnieuw gerenderd). */
  document.addEventListener('change', function (e) {
    var el = e.target;
    if (!el || !el.classList || !el.classList.contains('maravlo-sp__input') || busy) return;
    var wrap = el.closest('shipping-protection.maravlo-sp');
    if (!wrap) return;
    busy = true;
    var done = function (state) { refresh(state); busy = false; };
    var fail = function () { busy = false; };
    if (el.checked) {
      addProtection(wrap.getAttribute('data-variant-id')).then(done).catch(fail);
    } else {
      removeProtection(wrap.getAttribute('data-line-key')).then(done).catch(fail);
    }
  });

  /* Standaard AAN: andere items aanwezig, bescherming niet aanwezig, en niet handmatig uitgezet. */
  function ensureDefault() {
    if (busy) return;
    var wrap = document.querySelector('shipping-protection.maravlo-sp');
    if (!wrap) return;
    var present = wrap.getAttribute('data-sp-present') === 'true';
    var optout = wrap.getAttribute('data-sp-optout') === 'true';
    var count = parseInt(wrap.getAttribute('data-sp-count') || '0', 10);
    var variantId = wrap.getAttribute('data-variant-id');
    if (!present && !optout && count > 0 && variantId) {
      busy = true;
      addProtection(variantId)
        .then(function (state) { refresh(state); busy = false; })
        .catch(function () { busy = false; });
    }
  }

  document.addEventListener('DOMContentLoaded', ensureDefault);
  document.addEventListener('cart:refresh', ensureDefault);
  document.addEventListener('maravlo:cart:updated', ensureDefault);

  /* Dawn stuurt geen DOM-event bij add-to-cart; observeer de drawer-re-render. */
  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    setTimeout(function () { scheduled = false; ensureDefault(); }, 60);
  }
  function startObserver() {
    var cd = document.querySelector('cart-drawer');
    if (!cd) { return setTimeout(startObserver, 500); }
    new MutationObserver(schedule).observe(cd, { childList: true, subtree: true });
  }
  document.addEventListener('DOMContentLoaded', startObserver);
})();
